<Grid>

    <GridItem span="8-of-12">

        <ImageSlideshow images={images} autoplay interval={5000}/>

    </GridItem>

    <GridItem span="4-of-12" class="tint tint--primary">

        <div class="spacing spacing--padding-large text text--align-justify text--max-line-length">

            <h1>Bernhard Esperester</h1>

            <h2>3D Generalist</h2>

            <p>Als freiberuflicher 3D Generalist aus Berlin habe ich bereits mannigfaltige Erfahrungen gesammelt. Hierzu zählen Arbeiten an großen Hollywood Produktionen wie <strong>Captain America: Civil War</strong>, Fernsehserien wie <strong>Babylon Berlin</strong> oder Werbefilme für <strong>VW</strong> oder <strong>Mercedes Benz</strong>.</p>
                    
            <p><a href="mailto:bernhard@esperester.de?subject=Hire Me" class="button button--danger button--large button--highlight">Hire Me!</a></p> 
            
            <p>Folgen Sie mir bei <a href="https://www.linkedin.com/in/bernhardesperester/">LinkedIn</a> oder sehen Sie mehr in meinem <Link to="/blog/showreel-2018">Showreel</Link>.</p>
                            
        </div>

    </GridItem>

</Grid>

<SectionHeader>

    <h1>About Me</h1>

</SectionHeader>

<AboutMe />

<Blog limit={3} />

<script>
    import ImageSlideshow from 'components/ImageSlideshow.html'
    import Grid from 'components/Grid.html'
    import GridItem from 'components/GridItem.html'
    import Link from 'components/Link.html'

    // views
    import SectionHeader from 'views/compounds/SectionHeader.html'
    import Blog from 'Blog.html'
    import AboutMe from 'AboutMe.html'

    export default {
        components: {
            Blog,
            Grid,
            GridItem,
            ImageSlideshow,
            Link,
            AboutMe,
            SectionHeader
        },
        data() {
            return {
                images: [
                    {
                        title: 'Captain America: Civil War',
                        url: '/img/showreel-2018/risefx-captain-005.jpg'
                    },
                    {
                        title: 'VW Amarok',
                        url: '/img/showreel-2018/spellwork-vwamarok-001.jpg'
                    },
                    {
                        title: 'Mercedes',
                        url: '/img/showreel-2018/spellwork-mercedes-002.jpg'
                    }
                ]
            }
        }
    }
</script>